import * as React from "react";
import { MbnIcon } from "sb-resp-ui";
import { MarketsCountLiveOutright } from "../MarketsCountLiveOutright";
export const IconsWrapperLiveOutright = (props) => React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section-item rj-ev-list__${props.componentPrefix}__icons-holder`, "data-uat": `div-ev-list-${props.componentPrefix}-icons-holder` },
    props.details.event.mbnIcon &&
        React.createElement(MbnIcon, { tagNumber: props.details.event.mbnIcon.tagNumber }),
    !props.details.isDesktop &&
        React.createElement(MarketsCountLiveOutright, { selectionsCount: props.details.event.marketLinesCount, componentPrefix: props.componentPrefix }));
//# sourceMappingURL=IconsWrapperLiveOutright.js.map